export const luckydraw = {
    page_title : 'ลุ้นรางวัล',
}